import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => {
  return {
    container: {
      height: "100%",
      width: "100%",
      backgroundImage: `url(${require("Assets/img/background_video_survey.png")})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
      padding: "12px",
    },
    sectionConsultant: {
      background: "#FFFFFF",
      borderRadius: "8px",
      padding: "12px",
      marginTop: "12px",
      marginRight: "6px",
      height: "calc(100vh - 77px)",
      display: "flex",
      flexDirection: "row",
      gap: "16px",
    },
    section: {
      background: "#FFFFFF",
      borderRadius: "8px",
      borderTopLeftRadius: "0px",
      borderTopRightRadius: "0px",
      padding: "12px",
      margin: "0px 6px 0px 6px",
    },
    sectionContent: {
      height: "calc(100vh - 68px)",
    },
    toggleHidden: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      cursor: "pointer",
      "& svg": {
        color: "#465869",
      },
      "& span": {
        color: "#465869",
        fontFamily: "Manrope",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "16px",
        marginLeft: "5px",
      },
    },
    header: {
      background: "#FFF",
      borderRadius: "8px",
      height: "40px",
      padding: "12px 12px 0px 12px",
    },
  };
});

export default styles;
